import type { Theme } from "@mui/material";

/**
 * Shared chart tooltip style matching the landing page (ClaimsActivityChart).
 * Usage: <Tooltip contentStyle={getChartTooltipStyle(theme)} />
 */
export const getChartTooltipStyle = (theme: Theme) => ({
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
  fontSize: 12,
  backgroundColor: theme.palette.background.paper,
});

/**
 * Shared CartesianGrid props matching the landing page.
 * Usage: <CartesianGrid {...getCartesianGridProps(theme)} />
 */
export const getCartesianGridProps = (theme: Theme) =>
  ({
    strokeDasharray: "3 3",
    vertical: false,
    stroke: theme.palette.divider,
  }) as const;
